import React from "react";
import { t } from "i18next";
import { ICON_BASE_PATH } from "@/app/utils/config";

interface comingSoonProps {
  message?: string;
  className?: string;
  submessage?: string;
  iconType?: number;
}

const ComingSoon: React.FC<comingSoonProps> = ({
  message = "coming soon",
  submessage,
  className,
}) => {
  return (
    <div className={`${className ?? ""} gx-no-data-found-container`}>
      <div className="gx-no-data-found-wrapper">
        <div className="gx-datanot-error-child">
          <div className="gx-datanot-error">
            <img src={`${ICON_BASE_PATH}comingsoon1.png`} alt="Warning" />
          </div>
          <div>
            <p className="gx-datanot-errormessage gx-p18-sb">
              {t(message)} <span className="gx-p12-m">{submessage}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
